@if (cardBorderClass) {
  <product-pill class="ace-mode-pill-overlay" [pills]="product.productEntry?.[0]?.productPills"></product-pill>
}
<a href="{{ctaLink}}" rel="noopener noreferrer"
  [attr.aria-labelledby]="getIdToAriaLabelledbyContext(product.cardTitle, ctaLink)"
  (mouseover)="handleMouseOver()"
  (mouseout)="handleMouseOut()"
    class="h-full cursor-pointer p-6
    justify-start items-center gap-4 inline-flex w-full shadow-card rounded-ace-mode {{
    theme?.root
  }} {{ theme?.container }} {{ cardBorderClass }}">
  <div class="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
    <div class="self-stretch card-title wysiwyg" [innerHTML]="product.cardTitle"></div>
    @if (product.xGritProduct) {
      <div class="self-stretch">
        <span [ngClass]="{'mr-1': showStrikethrough }">{{priceText}}</span>
        @if (showStrikethrough && showOriginal) {
          <span class="line-through original-price font-extrabold">${{ product.xGritProduct?.apiData?.originalPrice | customNumber: '1.2-2'}}</span>
        }
        <span class="font-extrabold"> ${{ product.xGritProduct?.apiData?.discountPrice | customNumber: '1.2-2'}}</span>
      </div>
    }
  </div>
  <div class="self-center justify-self-end">
    <div  class="!w-12 h-12 !p-0 transition"
      [ngClass]="hoverClass"
      >
      <fa-icon class="leading-[0]" [icon]="faArrowRight"></fa-icon>
    </div>
  </div>
  <!-- Hidden Context -->
  <span [attr.id]="getIdToAriaLabelledbyContext(product.cardTitle, ctaLink)" class="sr-only">{{getTextContext(ctaLink)}}</span>
</a>
